define(() => {
    return (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext) => {
        const translateFn = TranslateService.instant;

        const ACTION_MSGS = {
            saveSubmission: {
                error: {
                    title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                    message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
                },
                progress: {
                    message: 'quoteandbind.common.config.FlowConfig.Saving quote submission details...'
                }
            }
        };

        const ACTIONS = {
            saveDraftSubmission: ({ value: submission }) => LoadSaveService.saveSubmission(null, submission).then(
                submissionDTO => ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext)
            )
        };

        return {
            contactDetails: (step, junction) => {
                step('paContactDetails', true)
                    .onNext.branch(
                    (model) => {
                        // If we come from quick quote go to intermediate step which will save the submission, otherwise
                        // carry on as normal to the next state.
                        return model.quoteID.value ? 'paQuickQuotePostContactDetails' : 'paContactDetailsComplete';
                    })
                    .skipOnResumeIf(({value: submission}) =>
                        submission.persons[0].emailAddress1 &&
                        submission.persons[0].firstName !== '0streamlinedquote0')
                    .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.Your Info'));

                junction('paQuickQuotePostContactDetails')
                    .onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission)
                    .thenGoTo('paContactDetailsComplete', 'error');

                junction('paContactDetailsComplete');

            },
            coverables: (step, junction) => {
                step('paPrequalQuestions', true)
                    .onNext.goTo('paMembership')
                    .skipOnResumeIf(({value: submission}, {agentportalnewsubmission}) =>
                        submission.draftData.lobs.personalAuto.preQualQuestionSets && !agentportalnewsubmission)
                    .isValid((model, isFormValid) => model.aspects.valid && model.aspects.subtreeValid && isFormValid)
                    .label(() => translateFn('quoteandbind.wizard.step.Qualification'));

                step('paMembership')
                    .onNext.goTo('paPrevCarrierInfo')
                    /*.isValid(model => model.aspects.valid && model.aspects.subtreeValid)*/
                    .label(() => translateFn('quoteandbind.wizard.step.Membership'));

                step('paPrevCarrierInfo')
                    .onNext.goTo('paDriverVehiclePrefillInfo')
                    .skipOnResumeIf(({value: submission}) =>
                submission.draftData.lobs.personalAuto.prevCarrierInfo && !agentportalnewsubmission)
                    .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.PreviousCarrierInfo'));


                step('paDriverVehiclePrefillInfo')
                    .onNext.goTo('paDriverDetails')
                    //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.PrefilledDriverVehicle'));



        step('paDriverDetails')
                    .onNext.goTo('paVehicleDetails')
                    .skipOnResumeIf(({value: submission}) =>
                        submission.draftData.lobs.personalAuto.drivers[0] &&
                        submission.draftData.lobs.personalAuto.drivers[0].licenseNumber &&
                        submission.draftData.lobs.personalAuto.drivers[0].licenseNumber !== '0streamlinedquote0')
                    //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.Drivers'));

                step('paVehicleDetails')
                    .onNext.goTo('paCoverablesComplete')
                    .skipOnResumeIf(({value: submission}) =>
                        submission.draftData.lobs.personalAuto.vehicles[0] &&
                        submission.draftData.lobs.personalAuto.vehicles[0].license &&
                        submission.quoteData && submission.quoteData.offeredQuotes &&
                        submission.draftData.lobs.personalAuto.vehicles[0].vin !== '0streamlinedquote0')
                    .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.Vehicles'));

                junction('paCoverablesComplete');
            },
            moreInfo: (step, junction) => {
                step('paPolicyInfo', true)
                    .onNext.goTo('paPolicySummary')
                    .skipOnResumeIf(({value: submission}) => submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1)
                    //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.Policy Info'));

                step('paPolicySummary')
                    .onNext.goTo('paEsignature')
                    //.onNext.goTo('paMoreInfoComplete')                
                    .skipOnResumeIf(({value: submission}) => submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1)
                    //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.Policy Summary'));
            
                step('paEsignature')
                    .onNext.goTo('paMoreInfoComplete')
                    .skipOnResumeIf(({value: submission}) => submission.accountHolder.phoneNumber && submission.accountHolder.emailAddress1)
                    //.isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                    .label(() => translateFn('quoteandbind.wizard.step.E-Signature'));

                junction('paMoreInfoComplete');
            }
        };
    };
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/pa/config/FlowConfig.js
 **/